import classnames from 'classnames';
import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import Scroll from '../../other/Scroll';
import AnimatedTitle from '../base/AnimatedTitle';
import styles from './TextAreaValueView.scss';
import useT from '../../utils/Translations/useT';
import { isRTL } from '../../../utils/commonHelper';
import loadable from '../../../utils/lazyLoading/loadable';
const PreviewRenderer = loadable(() => import('../base/PreviewRendering'), {
    fullScreen: false,
});
const ROW_HEIGHT = 20;
const DEFAULT_HEIGHT = 1500;
const TextAreaValueView = ({ label = '', noLabel = false, value = '', className = '', rows, isScroll = true, clobsPreviewData, hasRenderedPreview = false, }) => {
    const t = useT();
    const empty = isEmpty(value);
    const rtlClass = useMemo(() => (isRTL(value) ? styles.rtl : ``), [value]);
    const renderedValue = hasRenderedPreview ? (<PreviewRenderer hasRenderedPreview clobsPreviewData={clobsPreviewData} value={value}/>) : (value);
    return (<div className={classnames('form-group form-group-material')}>
      {!noLabel && (<AnimatedTitle value className={styles.label} placeholder={label}/>)}
      {isScroll ? (<Scroll hideTracksWhenNotNeeded autoHeightMax={rows ? rows * ROW_HEIGHT : DEFAULT_HEIGHT} className={classnames(styles.value, rtlClass, 'form-control', {
        [styles.noLabel]: noLabel,
        'empty-value': empty,
    }, className)}>
          {!empty && value ? renderedValue : null}
          {empty && t('None')}
        </Scroll>) : (<div className={classnames(styles.value, rtlClass, {
        [styles.noLabel]: noLabel,
        'empty-value': empty,
    }, className)}>
          {!empty && value ? renderedValue : null}
          {empty && t('None')}
        </div>)}
    </div>);
};
export default TextAreaValueView;
